import {ssrGetNavigationPopular} from '~/graphql/operations/navigation-popular/get-navigation-popular.generated';

export async function getLitGameNavigationPopular(locale: string) {
  const id = '2zJXLwD30Z9LotXMFjYpof';
  const {
    props: {data},
  } = await ssrGetNavigationPopular.getServerPage(
    {
      variables: {
        id,
        locale,
      },
    },
    {}
  );
  return data?.navigationPopular ?? {};
}
